import { Icon, Tooltip } from '@genial/components';
import { Box } from 'native-base';
import React from 'react';

export interface MonthlyContributionTooltipProps {
  minimumApplicationNormalized: string;
  monthlyMinimumApplicationNormalized: string;
}

export const MonthlyContributionTooltip: React.FC<MonthlyContributionTooltipProps> = ({
  minimumApplicationNormalized,
  monthlyMinimumApplicationNormalized,
}) => {
  return (
    <Tooltip
      width="320px"
      label={`Se a contribuição mensal for igual ou maior que ${monthlyMinimumApplicationNormalized}, o aporte inicial poderá ser menor que ${minimumApplicationNormalized}.`}>
      <Box>
        <Icon name="Info" size="xxs" />
      </Box>
    </Tooltip>
  );
};
